const styles = {
    section: 'w-10/12 mx-auto',
    button: ' py-[12px] px-[35px] duration-[0.5s] hover:bg-blue-500 text-white text-[14px] rounded-[50px] leading-[1px] font-medium cursor-pointer bg-[#1977cc]',
    h1: 'text-[25px] font-semibold',
};

export default styles;
